import { Vector2 } from '@adaptiva/core/space';
import { BaseWidgetComponent, provideBaseWidget } from '@adaptiva/core/widgets';
import { IconComponent } from '@adaptiva/widgets/icon';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { IViewbox } from '../viewbox.interface';

@Component({
	selector: '[ada-viewbox-control]',
	templateUrl: './viewbox-control.component.html',
	styleUrls: ['./viewbox-control.component.scss'],
	imports: [
		CommonModule,
		IconComponent,
	],
	providers: [provideBaseWidget(() => ViewboxControlComponent)],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewboxControlComponent extends BaseWidgetComponent {

	public readonly zoomFactor: InputSignal<float> = input(50);

	protected host: IViewbox = inject(IViewbox);

	protected zoomIn(): void {
		this.host.applyTransition();
		const _deltaZ: float = Math.max(this.host.minZoom(), this.host.z() + (this.zoomFactor() * this.host.zoomFactor()));

		this._zoomStep(_deltaZ);
	}

	protected zoomOut(): void {
		this.host.applyTransition();
		const _deltaZ: float = Math.max(this.host.minZoom(), this.host.z() - (this.zoomFactor() * this.host.zoomFactor()));

		this._zoomStep(_deltaZ);
	}

	private _zoomStep(_amount: float): void {
		const _world: Vector2 = this.host.getCenter();
		const _scaler: float = this.host.z() - _amount;

		this.host.x.update((_x) => _x + (_world.x * _scaler));
		this.host.y.update((_y) => _y + (_world.y * _scaler));
		this.host.z.set(_amount);
		this.host.repaint(this.host.x(), this.host.y(), this.host.z());
	}

	protected togglePan(): void {
		this.host.canPan.set(!this.host.canPan());
	}

	protected resetView(): void {
		this.host.applyTransition();
		this.host.x.set(0);
		this.host.y.set(0);
		this.host.z.set(1);
		this.host.repaint(0, 0, 1);
	}

}
